import React from 'react';

import classes from './classes.module.css';
import { notIsEmptyString } from '../../../../../utils';
import ButtonBase from '@material-ui/core/ButtonBase';

export default class CaseStudy extends React.PureComponent {

    render = () => {
        const { style, image, image_footing, heading, content, footing, cta_text, cta_link, button_style } = this.props;
        return <div className={classes.container} style={style}>
            <div className={classes.imageContainer}>
                <img className={classes.image} src={image} />
                {notIsEmptyString(cta_text) && <a href={cta_link} target='_blank'>
                    <ButtonBase style={button_style}>{cta_text}</ButtonBase>
                </a>}
            </div>
            <div className={classes.contentContainer}>
                <div className={classes.heading}>{heading}</div>
                <div className={classes.content}>{content}</div>
                <div className={classes.footing}>{footing}</div>
            </div>
        </div>;
    }

}